const RELATIONSHIP_TYPES = {
  CHILD: 'child',
  EMPLOYEE: 'employee',
  LIFE_PARTNER: 'life_partner',
  OTHER: 'other',
  SPOUSE: 'spouse',
};

const FILL_DEPENDENT_RELATIONSHIP_CONFIG = {
  child: {
    optionConfig: {
      optLabel: 'onboarding.relationship_child',
      optValue: RELATIONSHIP_TYPES.CHILD,
    },
  },
  employee: {
    optionConfig: {
      optLabel: 'onboarding.relationship_employee',
      optValue: RELATIONSHIP_TYPES.EMPLOYEE,
    },
  },
  life_partner: {
    optionConfig: {
      optLabel: 'onboarding.relationship_lifepartner',
      optValue: RELATIONSHIP_TYPES.LIFE_PARTNER,
    },
  },
  spouse: {
    optionConfig: {
      optLabel: 'onboarding.relationship_spouse',
      optValue: RELATIONSHIP_TYPES.SPOUSE,
    },
  },
  other: {
    optionConfig: {
      optLabel: 'onboarding.relationship_other',
      optValue: RELATIONSHIP_TYPES.OTHER,
    },
  },
};

const relationshipOpts = Object.values(FILL_DEPENDENT_RELATIONSHIP_CONFIG).map(agentType => agentType.optionConfig);

export { RELATIONSHIP_TYPES, FILL_DEPENDENT_RELATIONSHIP_CONFIG, relationshipOpts };
